var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.319,
    height: 20,
    viewBox: "0 0 13.319 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12507",
    "data-name": "Group 12507",
    transform: "translate(-1423.21 -2358.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M.645,20A.656.656,0,0,1,0,19.333V.667A.656.656,0,0,1,.645,0H7.677a.636.636,0,0,1,.433.17l5,4.666a.679.679,0,0,1,.21.5c0,.008,0,.017,0,.025V19.333a.656.656,0,0,1-.646.667Zm.646-1.333H12.028V6.067l-4.347.047a.581.581,0,0,1-.457-.194.675.675,0,0,1-.194-.473V1.36H1.29ZM8.322,4.743h.3L11,4.718,8.322,2.17Z",
    transform: "translate(1423.21 2358.12)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12506",
    "data-name": "Group 12506",
    transform: "translate(1426.074 2366.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,3.8a.418.418,0,1,1,.835,0A2.957,2.957,0,1,0,3.792.848a2.922,2.922,0,0,0-1.474.4l.038.021A.421.421,0,0,1,1.938,2l-.51-.3a.417.417,0,0,1-.3-.361L1.04.543A.42.42,0,1,1,1.875.459l.006.06A3.792,3.792,0,1,1,3.792,7.584V7.6A3.8,3.8,0,0,1,0,3.8Z",
    transform: "translate(0 0)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M40.417,30.042a.35.35,0,0,1-.246-.6l.675-.678V27.522a.352.352,0,1,1,.7,0v1.406a.352.352,0,0,1-.1.246l-.78.78A.352.352,0,0,1,40.417,30.042Z",
    transform: "translate(-37.154 -24.955)",
    fill: "#74613c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.58fa6cabe15688a7617834e3aa18887f.svg";
export { ForwardRef as ReactComponent };